// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('main.dashboard', {
        url: '/dashboard',
        templateUrl: 'main/base/dashboard/dashboard.tpl.html',
        controller: 'MainDashboardController as vm',
        resolve: {
            initialData: ['DashboardApiService', '$q', function(DashboardApiService, $q) {
                return $q.all({
                    widgetDefinitions: DashboardApiService.getWidgetDefinitions(),
                    widgets: DashboardApiService.getWidgets()
                });
            }]
        }
    });
}

// @ngInject
function MainDashboardController($scope, initialData) {
    $scope.widgetDefinitions = initialData.widgetDefinitions.data;
    $scope.widgets = initialData.widgets.data || [];
}

angular
    .module('base.dashboard', ['dashboard.api'])
    .config(stateConfig)
    .controller('MainDashboardController', ['$scope', 'initialData', MainDashboardController]);
